<template>
  <div id="DataVersionInfo" v-loading="loading">
    <el-collapse v-model="activeNames" :accordion="accordion" class="VersionManage_list">
      <el-collapse-item v-for="(item, index) in dataVersionList" :key="index" class="VersionManage_item" :name="item.resourceDataVersionId">
        <template slot="title">
          <div class="VersionManage_item_title">{{ item.version }}</div>
          <el-tooltip effect="dark" content="在应用端可直接使用该版本资源" placement="top">
            <div v-show="item.status" class="VersionManage_item_status">当前启用</div>
          </el-tooltip>
          <div class="VersionManage_item_oper">
            <el-button
                v-if="item.status && showPlaceButton"
                type="text"
                :disabled="hasPermission(dataVersionInfo.permissionType, getPermissionKey('PLACE')) || clientTypeSoftwareVersion < dataVersionInfo.resourceSoftwareVersion"
                @click.stop="$emit('toPlace')"
            >布置</el-button>
            <el-button
                v-if="item.status && showLoadButton"
                type="text"
                :disabled="hasPermission(dataVersionInfo.permissionType, getPermissionKey('LOAD')) || clientTypeSoftwareVersion < dataVersionInfo.resourceSoftwareVersion"
                @click.stop="$emit('toLoad')">载入</el-button>
            <el-button v-if="clientType === 'web'" type="text" :loading="item.downloadLoading" :disabled="hasPermission(dataVersionInfo.permissionType, getPermissionKey('DOWNLOAD'))" @click.stop="download(item)">下载</el-button>
            <el-button v-if="!item.status" type="text" :disabled="hasPermission(dataVersionInfo.permissionType, getPermissionKey('DATA_VERSION_ENABLE'))" @click.stop="open(item)">启用</el-button>
            <el-button v-if="!item.status" type="text" :disabled="hasPermission(dataVersionInfo.permissionType, getPermissionKey('DATA_VERSION_DELETE'))" @click.stop="del(item)">删除</el-button>
          </div>
        </template>
        <div v-for="(item2, index2) in item.records || []" :key="index2" class="VersionManage_item_record">
          <span class="operationDate">{{ $fmtTime(item2.operationDate) }}</span>
          <span class="userName ellipsis-text" :title="item2.userName">{{ item2.userName }}</span>
          <span class="operation ellipsis-text" :title="item2.operation">{{ item2.operation }}</span>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import permissionMixin from '@/mixins/permissionMixin.js'
import Utils from '@/core/utils'
export default {
  name: 'DataVersionInfo',
  mixins: [permissionMixin],
  props: {
    currentSubmodule: {
      type: String
    },
    resourceType: {
      type: String,
      default: 'COMPONENT',
    },
    accordion: {
      type: Boolean,
      default: false
    },
    spaceId: {
      type: [String, Number],
      default: ''
    },
    publicId: {
      type: [String, Number],
      default: ''
    },
    versionId: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      loading: false,
      activeNames: []
    }
  },
  computed: {
    ...mapGetters({
      dataVersionList: 'resourceDetail/dataVersionList',
      dataVersionInfo: 'resourceDetail/dataVersionInfo',
      currentResource: 'resourceDetail/currentResource',
      clientType: 'platform',
      clientTypeSoftwareCode: 'softwareCode',
      clientTypeSoftwareVersion: 'softwareVersion',
      isCapitalSoftware: 'isCapitalSoftware',
      versionResourceInfo: 'resourceDetail/versionResourceInfo',
      versionFileInfo: 'resourceDetail/versionFileInfo',
    }),
    showPlaceButton() {
      const hasMatchedSoftwareCode = Array.isArray(this.versionResourceInfo.softwareList) && !!this.versionResourceInfo.softwareList.find((item) => item.softwareCode === this.clientTypeSoftwareCode)
      return this.clientType !== 'web' && ['COMPONENT'].includes(this.resourceType) && !this.isCapitalSoftware && hasMatchedSoftwareCode
    },
    showLoadButton() {
      const hasMatchedSoftwareCode = Array.isArray(this.versionResourceInfo.softwareList) && !!this.versionResourceInfo.softwareList.find((item) => item.softwareCode === this.clientTypeSoftwareCode)
      return this.clientType === 'g' && hasMatchedSoftwareCode
    }
  },
  watch: {
    dataVersionList: {
      handler(nval, oval) {
        if (nval && nval.length > 0) {
          const item = nval.find((f) => f.status)
          this.activeNames = item ? item.resourceDataVersionId : nval[0].resourceDataVersionId
        }
      },
      setImmediate: true,
    }
  },
  created() {
    if (this.dataVersionList && this.dataVersionList.length) {
      const item = this.dataVersionList.find((f) => f.status)
      this.activeNames = item ? item.resourceDataVersionId : this.dataVersionList[0].resourceDataVersionId
    }
  },
  methods: {
    ...mapActions({
      loadVersionResourceDataVersionInfo: 'resourceDetail/loadVersionResourceDataVersionInfo',
    }),
    getPermissionKey (key) {
      const platform = Utils.splitPlatform(this.currentSubmodule)
      return `${platform}_${this.resourceType}_${key}`
    },
    // 启用
    open(item) {
      this.$confirm('确定启用该版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.loading) {
          return false
        }
        if (item.status) {
          return false
        }
        this.$api.resource.enableDataVersion(this.spaceId, this.publicId, this.versionId, item.resourceDataVersionId).then((res) => {
          if (res === true) {
            this.dataVersionList.forEach((element) => {
              element.status = false
            })
            item.status = true
            this.activeNames = item.resourceDataVersionId
            this.$emit('version-changed', item.resourceDataVersionId)
          }
        }).catch(() => {
          this.$message.error('启用数据版本失败')
        }).finally((e) => {
          this.loading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用该版本'
        })
      })
    },
    // 下载
    download(item) {
      if (item.downloadLoading) {
        return false
      }
      this.$set(item, 'downloadLoading', true)
      this.$api.resource.getDownloadUrl(this.spaceId, this.publicId, this.versionId, item.resourceDataVersionId).then((res) => {
        if (res) {
          this.$downloadFile(res)
          const eventMap = {
            COMPONENT: 'downloadSpaceComponent',
            MODULE: 'downloadSpaceModule',
            SCHEME: 'downloadSpaceScheme',
          }
          const eventName = eventMap[this.resourceType]
          this.$tracks({
            event: eventName,
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: this.publicId,
            }
          })
        } else {
          this.$message.error('获取下载地址失败')
        }
      }).catch(() => {
        this.$message.error('获取下载地址失败')
      }).finally((e) => {
        item.downloadLoading = false
      })
    },
    // 删除
    del(item) {
      this.$confirm('确定删除该版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.loading) {
          return false
        }
        if (item.status) {
          return false
        }
        this.$api.resource.delDataVersion(this.spaceId, this.publicId, this.versionId, item.resourceDataVersionId).then((res) => {
          if (res) {
            this.loadVersionResourceDataVersionInfo({
              space_id: this.currentResource.spaceId,
              space_resource_id: this.currentResource.spaceResourceId,
              resource_software_version_id: this.currentResource.versionId,
            })
            const eventMap = {
              COMPONENT: 'deleteSpaceComponent',
              MODULE: 'deleteSpaceModule',
              SCHEME: 'deleteSpaceScheme',
            }
            const eventName = eventMap[this.resourceType]
            this.$tracks({
              event: eventName,
              params: { g_c_space_id: this.spaceId, }
            })
          } else {
            this.$message.error('删除数据版本失败')
          }
        }).catch(() => {
          this.$message.error('删除数据版本失败')
        }).finally((e) => {
          this.loading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.VersionManage_item:first-child {
  /deep/.el-collapse-item__header {
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
  }
}
.VersionManage_item {
  /deep/.el-collapse-item__header {
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
    height: 32px;
    line-height: 32px;
    padding-left: 40px;
    position: relative;
    font-size: 14px;
    .VersionManage_item_title {
      flex-basis: 20%;
    }
    .VersionManage_item_status {
      background: #E6F7FF;
      color: @theme-color;
      border: 1px solid #91D5FF;
      border-radius: 2px;
      height: 22px;
      line-height: 22px;
      width: 74px;
      text-align: center;
      font-size: 12px;
      margin-left: 5px;
    }
    .VersionManage_item_oper {
      display: flex;
      justify-content: right;
      width: 90%;
      margin-right: 8px;
    }
  }
  /deep/.el-collapse-item__arrow {
    position: absolute;
    left: 15px;
  }

  /deep/.el-collapse-item__content {
    padding: 4px 0;
    font-size: 12px;
    .VersionManage_item_record {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      padding: 4px 16px;
      color: rgba(73, 95, 112, 0.6);
      .operationDate {
        flex: 0 0 104px;
        padding-left: 24px;
      }
      .userName {
        flex: 0 0 100px;
        width: 100px;
        margin: 0 14px;
      }
      .operation {
        flex: 1;
        text-align: right
      }
    }
  }
}
.VersionManage_item.is-active + .VersionManage_item {
  /deep/.el-collapse-item__header {
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
  }
}

</style>
